import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface UsdtDestinationData {
  clpAmount: number;
  usdtAmount: number;
  rate: number;
  sendFormatted?: string;
  receiveFormatted?: string;
  // Optional text overrides for reuse (e.g., VES flow)
  title?: string;
  subtitle?: string;
  walletTitle?: string;
  walletDescription?: string;
  walletBenefits?: string[];
  withdrawTitle?: string;
  withdrawDescription?: string;
  withdrawWarning?: string;
}

export type UsdtDestinationType = 'wallet' | 'withdraw';

export interface UsdtDestinationResult {
  destination: UsdtDestinationType;
  data: UsdtDestinationData;
}

@Component({
  selector: 'app-usdt-destination-modal',
  templateUrl: './usdt-destination-modal.component.html',
  styleUrls: ['./usdt-destination-modal.component.sass']
})
export class UsdtDestinationModalComponent {
  selectedOption: UsdtDestinationType = 'wallet';
  isLoading = false;

  constructor(
    public dialogRef: MatDialogRef<UsdtDestinationModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: UsdtDestinationData
  ) {}

  selectOption(option: UsdtDestinationType): void {
    this.selectedOption = option;
  }

  onCancel(): void {
    this.dialogRef.close(null);
  }

  onConfirm(): void {
    const result: UsdtDestinationResult = {
      destination: this.selectedOption,
      data: this.data
    };
    this.dialogRef.close(result);
  }

  formatCLP(value: number): string {
    return new Intl.NumberFormat('es-CL', {
      style: 'currency',
      currency: 'CLP',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(value);
  }

  formatUSDT(value: number): string {
    return new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(value) + ' USDT';
  }
}
